import { useMemo } from 'react';

import { useDatahubTabs } from './useDatahubTabs.hook';

import { TestID } from '../testID';

import type { DataEntityTypes } from '../types/common.types';
import type { DataEntityTabs } from '../types/dataEntitiesTabs.types';

export const useEntitiesTabs = (entityType: DataEntityTypes, subscriptionId: string) => {
  const datahubTabs = useDatahubTabs(subscriptionId);

  const tabs = useMemo(() => {
    const all: DataEntityTabs = {
      systems: [
        {
          id: 'list-all',
          label: 'List all',
          to: `/subscription/${subscriptionId}/systems/all`,
          tooltip: 'List all tab',
          testId: TestID.SystemsListAllTab,
        },
        {
          id: 'permissions',
          label: 'Permissions',
          to: `/subscription/${subscriptionId}/systems/permissions`,
          tooltip: 'Permissions tab',
          testId: TestID.SystemsPermissionsTab,
        },
        {
          id: 'prototype-permissions',
          label: 'Prototype permissions',
          to: `/subscription/${subscriptionId}/systems/prototype-permissions`,
          tooltip: 'Prototype permissions tab',
          testId: TestID.SystemsPrototypePermissionsTab,
        },
        {
          id: 'internal-systems',
          label: 'Internal systems',
          to: `/subscription/${subscriptionId}/systems/internal-systems`,
          tooltip: 'Internal systems tab',
          testId: TestID.SystemsInternalSystemsTab,
        },
      ],
      pipes: [
        {
          id: 'list-all',
          label: 'List all',
          to: `/subscription/${subscriptionId}/pipes/all`,
          tooltip: 'List all tab',
          testId: TestID.PipesListAllTab,
        },
        {
          id: 'permissions',
          label: 'Permissions',
          to: `/subscription/${subscriptionId}/pipes/permissions`,
          tooltip: 'Permissions tab',
          testId: TestID.PipesPermissionsTab,
        },
        {
          id: 'prototype-permissions',
          label: 'Prototype permissions',
          to: `/subscription/${subscriptionId}/pipes/prototype-permissions`,
          tooltip: 'Prototype permissions tab',
          testId: TestID.PipesPrototypePermissionsTab,
        },
        {
          id: 'internal-pipes',
          label: 'Internal pipes',
          to: `/subscription/${subscriptionId}/pipes/internal-pipes`,
          tooltip: 'Internal pipes tab',
          testId: TestID.PipesInternalPipesTab,
        },
      ],
      datasets: datahubTabs,
    };

    return all[entityType] ?? [];
  }, [subscriptionId]);

  return tabs;
};
